import React, { FC, ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import { clsx } from 'clsx';
// Components
import Text from './text';

interface LoaderProps extends CircularProgressProps {
    noFlex?: boolean;
    containerClassName?: string;
    text?: string;
    delay?: number;
}

const Loader: FC<LoaderProps> = ({ containerClassName, noFlex, color, text, ...rest }): ReactElement => {
    const classes = useStyles();

    const [show, setShow] = React.useState(!rest.delay);

    React.useEffect(() => {
        if (rest.delay) {
            const timer = setTimeout(() => setShow(true), rest.delay);
            return () => clearTimeout(timer);
        }
        return () => {}; // Cleanup function to avoid memory leaks
    }, [rest.delay]);

    if (!show) return null;

    return (
        <div className={clsx(!noFlex && classes.center, containerClassName)}>
            <CircularProgress color={color} {...rest} />
            {text && <Text.Description14 text={text} />}
        </div>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        center: {
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
        },
    }),
);

export default Loader;
